import { hapticHeavy, hapticVibrate } from '@skippay/core/utils/hapticUtils';

import { DEFAULT_TIMEOUT, SEVERITY_ERROR, SEVERITY_SUCCESS, SEVERITY_WARNING } from './constants';

export const SPAWN_NOTIFICATION = 'slip/notifications/SPAWN_NOTIFICATION';

export function spawnNotification(
	id,
	severity,
	title,
	content,
	customElement,
	timeout = DEFAULT_TIMEOUT
) {
	return {
		type: SPAWN_NOTIFICATION,
		payload: {
			id,
			severity,
			title,
			content,
			timeout,
		},
	};
}

export const DESTROY_NOTIFICATION = 'slip/notifications/DESTROY_NOTIFICATION';

/**
 * Destroys notifications by id.
 * @param { string | string[] } ids of notifications to destroy or empty to destroy all
 * @return { TAction }
 */
export function destroyNotification(ids) {
	return {
		type: DESTROY_NOTIFICATION,
		payload: {
			ids: ids && [].concat(ids),
		},
	};
}

/**
 * @typedef {{
 * 	content?: string,
 * 	id: string
 * 	timeout?: number
 * 	title?: string | ReactNode
 * }} NotificationPayload
 */

/**
 * @param { NotificationPayload } payload
 */
export function spawnNotificationError({ content, id, timeout, title }) {
	hapticVibrate();
	return spawnNotification(id, SEVERITY_ERROR, title, content, undefined, timeout);
}

/**
 * @param { NotificationPayload } payload
 */
export function spawnNotificationSuccess({ content, id, timeout, title }) {
	hapticHeavy();
	return spawnNotification(id, SEVERITY_SUCCESS, title, content, undefined, timeout);
}

/**
 * @param { NotificationPayload } payload
 */
export function spawnNotificationWarning({ content, id, timeout, title }) {
	hapticHeavy();
	return spawnNotification(id, SEVERITY_WARNING, title, content, undefined, timeout);
}
